import { AmazonS3LinkedService } from 'app/model/linkedservice/amazon-s3.linkedservice';
import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { FileTypeDataset } from './file-type.dataset';

import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.amazonS3.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AmazonS3_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AmazonS3_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AmazonS3LinkedService.MODEL // Linked service redefined
        }
    }
})
export class AmazonS3Dataset extends FileTypeDataset {
    public static readonly MODEL: IModel;
    public static readonly BUCKET_NAME: IAttribute;
    @Metamodel.attribute({
        display: stringResources.ModelName_BucketName,
        association: 'BUCKET_NAME',
        templatable: true
    })
    public bucketName?: string;
    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
